import { type ReactNode } from "react";
import { ComposerActionProvider, ComposerFab } from "../primitives/ComposerActionContext";
import { CommunitySubNav } from "./CommunitySubNav";
import { CommunityShellContext } from "./CommunityShellContext";

export interface CommunityShellProps {
  children: ReactNode;
}

export function CommunityShell({ children }: CommunityShellProps) {
  return (
    <CommunityShellContext.Provider value={true}>
      <ComposerActionProvider>
        <div className="relative min-h-dvh" data-testid="community-shell">
          {/* Sticky sub-nav: bottom-fixed on mobile, sticky-top on tablet, hidden on desktop */}
          <CommunitySubNav />

          {/* Main content area — bottom padding prevents overlap with mobile tab bar */}
          <div className="pb-[calc(env(safe-area-inset-bottom)+72px)] sm:pb-0">
            {children}
          </div>

          {/* Composer FAB — only on mobile, only when a page registers an action.
              Positioned above the bottom tab bar (72px) with 16px gap. */}
          <ComposerFab className="bottom-[calc(env(safe-area-inset-bottom)+88px)]" />
        </div>
      </ComposerActionProvider>
    </CommunityShellContext.Provider>
  );
}
